import ConfirmationDialog from "./ConfirmationDialog";
import { createConfirmation } from "react-confirm";

const confirm = createConfirmation(ConfirmationDialog);

export default function(confirmation, options = {}) {
  return confirm({ confirmation, options });
}
